export const Tiers = Object.freeze({
  AD_SUPPORTED: 'AD_SUPPORTED',
  PANDORA_PLUS: 'PANDORA_PLUS',
  PANDORA_PREMIUM: 'PANDORA_PREMIUM',
  PANDORA_FAMILY: 'PREMIUM_FAMILY_PLAN',
});

export const DiscountTypes = Object.freeze({
  NONE: 'NONE',
  STUDENT: 'STUDENT',
  MILITARY: 'MILITARY',
});

export const Actions = Object.freeze({
  CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
  ANONYMOUS_START_TRIAL_CLICKED: 'ANONYMOUS_START_TRIAL_CLICKED',
  UPGRADE_OFFERED: 'UPGRADE_OFFERED',
  LOG_UPGRADE_PAGE_EVENT: 'LOG_UPGRADE_PAGE_EVENT',
  UPGRADE_CONFIRMATION: 'UPGRADE_CONFIRMATION',
  TOGGLE_SWITCHING_PLANS: 'TOGGLE_SWITCHING_PLANS',
  UPDATING_BILLING_INFO: 'UPDATING_BILLING_INFO',
  ACQUIRE_OFFER_SUCCESS: 'ACQUIRE_OFFER_SUCCESS',
  LISTENER_AND_SUBSCRIPTION_READY: 'LISTENER_AND_SUBSCRIPTION_READY',
  UPGRADE_CTA_CLICK: 'UPGRADE_CTA_CLICK',
  UPGRADE_DISCOUNT_PLAN_LINK_CLICKED: 'UPGRADE_DISCOUNT_PLAN_LINK_CLICKED',
});
